import { Box, Button, Dialog, DialogContent } from "@mui/material";
import React, { useState } from "react";
import Splitter from "../../sign-in-splitter/Splitter";
import CloseIcon from "@mui/icons-material/Close";
import AgentLogin from "../../agent/agent-sign-in/AgentLogin";

const AgentLoginDialog = ({ open, onClose }) => {
  const [isAgentLogin, setIsAgentLogin] = useState(true);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: "750px",
            height: "423px",
            borderRadius: "10px",
            overflow: "hidden",
            boxShadow: "0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04)"
          },
        }}
        aria-labelledby="agent-login-dialog"
      >
        <DialogContent sx={{ p: 0, height: "100%", overflow: "hidden" }}>
          <Box className="auth-dialog">
            {/* LEFT – SPLITTER */}
            <Box className="auth-left">
              <Splitter variant="login" />
            </Box>

            {/* RIGHT – FORM */}
            <Box className="auth-right">
              <Button
                onClick={onClose}
                sx={{
                  position: 'absolute',
                  top: 1,
                  right: 1,
                  minWidth: 'auto',
                  p: 1,
                  color: '#64748B',
                  '&:hover': { color: '#0F172A', background: '#F1F5F9' },
                  zIndex: 10
                }}
              >
                <CloseIcon />
              </Button>
              <AgentLogin onClose={onClose} />
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default AgentLoginDialog